/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'track': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<g transform="translate(-2.25 -1.682)" _stroke="#000" _fill="none" fill-rule="evenodd"><path pid="0" d="M11.536 4.464a5 5 0 0 1 0 7.072L8 15.07l-3.536-3.535a5 5 0 1 1 7.071-7.071z"/><circle pid="1" cx="8" cy="7.537" r="1.262"/></g>'
  }
})
